export interface Project {
  index: string;
  title: string;
  tags: string[];
  year: string;
  desc: string;
  github: string;
  live?: string;
}

export function renderProjectCard(project: Project): string {
  const rotation = parseInt(project.index, 10) % 2 === 0 ? '2.5deg' : '-2.5deg';

  return `
    <article class="project-card">
      <span class="project-index">${project.index}</span>
      <div class="project-details">
        <h3 class="project-title">${project.title}</h3>
        <p class="project-desc">${project.desc}</p>
        <div class="tech-labels">
          ${project.tags
            .map(
              (tag, idx) => `
              <span class="tech-wrapper">
                <span class="tech-tag">${tag}</span>
                ${idx < project.tags.length - 1 ? '<span class="tag-spacer">|</span>' : ''}
              </span>
            `
            )
            .join('')}
        </div>
        <div class="project-actions">
          <a href="${project.github}" target="_blank" rel="noopener noreferrer" class="action-link" aria-label="View source code for ${project.title}">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M12 2C6.477 2 2 6.484 2 12.021c0 4.428 2.865 8.184 6.839 9.504.5.092.682-.217.682-.482 0-.237-.009-.868-.013-1.703-2.782.605-3.369-1.342-3.369-1.342-.454-1.154-1.11-1.462-1.11-1.462-.908-.62.069-.608.069-.608 1.003.07 1.532 1.032 1.532 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844a9.59 9.59 0 012.504.338c1.909-1.296 2.747-1.026 2.747-1.026.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.748 0 .268.18.58.688.482C19.138 20.2 22 16.447 22 12.021 22 6.484 17.523 2 12 2z" />
            </svg>
            Source Code
          </a>
          ${
            project.live
              ? `
              <span class="tag-spacer">|</span>
              <a href="${project.live}" target="_blank" rel="noopener noreferrer" class="action-link" aria-label="View live demo of ${project.title}">
                <span class="live-dot" aria-hidden="true"></span>
                Live Demo
              </a>
            `
              : ''
          }
        </div>
      </div>
      
      <!-- Cinnabar Year Seal -->
      <div class="project-year-stamp" style="--rotation: ${rotation};" aria-label="Year ${project.year}">
        <span>${project.year}</span>
      </div>
    </article>
  `;
}